import * as React from 'react';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { RootState } from '../store';
import { setSnackMsgAction } from '../store/slice';
import { styled } from '@mui/material/styles';

// Create a styled Snackbar component that handles the ownerState prop internally
const StyledSnackbar = styled(Snackbar)({}) as typeof Snackbar;

export default function SnackMsg() {
  const snackMsg = useSelector((state: RootState) => state.snackMsg);
  const dispatch = useDispatch();

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }

    dispatch(setSnackMsgAction(""));
  };

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  return (
    <div>
      <StyledSnackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={snackMsg !== ""}
        onClose={handleClose}
        message={snackMsg}
        action={action}
        sx={{
          mt: 10
        }}
      />
    </div>
  );
}
